import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "running-job-list pt-4 pb-4"
};
const _hoisted_2 = {
  key: 0,
  class: "running-job-box"
};
const _hoisted_3 = {
  key: 0,
  class: "job-item-inner"
};
const _hoisted_4 = {
  key: 0,
  class: "progress"
};
import nodata from "@/assets/img/no-data.png";

// eslint-disable-next-line no-undef

export default {
  __name: 'TaskList',
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_empty = _resolveComponent("el-empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "job-item",
          key: item.id
        }, [item.progress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [item.progress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_progress, {
          type: "circle",
          percentage: item.progress,
          width: 100,
          color: "#47fff1"
        }, null, 8, ["percentage"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_el_image, {
          key: 1,
          fit: "cover"
        }, {
          error: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
            class: "image-slot"
          }, [_createElementVNode("i", {
            class: "iconfont icon-quick-start"
          }), _createElementVNode("span", null, "任务正在排队中")], -1)])),
          _: 1
        }))]);
      }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无任务"
      }, null, 8, ["image"]))]);
    };
  }
};